export const sortTabs = (tabs) => tabs?.sort((a, b) => {
	const orderArray = ["description", "question", "dimensions", "shipping", "installation"];
	const getOrderIndex = (tab) => orderArray.findIndex(item => tab?.title.toLowerCase().includes(item));
	return getOrderIndex(a) - getOrderIndex(b);
});